import React from "react";
import { observable, action } from "mobx";
import { observer } from "mobx-react";
import SuccessGif from "Assets/gif/sucessGif.gif";

class AcknowledgementPopupState {
  @observable showPopup = false;

  defaultPopupValue = {
    title: "",
    content: "",
    note: "",
    actionBtnText: "",
    callback: () => {},
    dynamicDom: false,
    id: "",
    btnClassName: ""
  };

  @observable popupValues = { ...this.defaultPopupValue };

  @action
  setShowPopup = (val = false) => {
    this.showPopup = val;
    if (val) {
      document.getElementsByTagName("body")[0].classList.add("scrollHidden");
    } else {
      this.popupValues = { ...this.defaultPopupValue };
      document.getElementsByTagName("body")[0].classList.remove("scrollHidden");
    }
  };

  @action
  setPopupValues = (val = {}) => {
    this.popupValues = {
      ...this.defaultPopupValue,
      ...val
    };
  };
}

const acknowledgementPopupState = new AcknowledgementPopupState();

const AcknowledgementPopup = () => {
  if (!acknowledgementPopupState.showPopup) return "";

  const { title, content, note, actionBtnText, callback, btnClassName, id } =
    acknowledgementPopupState.popupValues;

  const handleAction = () => {
    if (callback) {
      callback();
    }
    acknowledgementPopupState.setShowPopup(false);
  };

  return (
    acknowledgementPopupState?.showPopup && (
      <div className="popupWrapper acknowledgementPopupWrapper">
        <div className="acknowledgement-popup common-popup">
          <div
            data-id="notify-popup"
            className="popup-wrap animatedFast slideInDownTranslate acknowledgementPopup"
          >
            <div className="acknowledgement-icon">
              <img
                src={SuccessGif}
                alt="Success"
                className="acknowledgement-icon-img"
              />
            </div>
            <div className="acknowledgement-title">{title}</div>
            <div className="acknowledgement-message">{content}</div>
            {note && (
              <div className="acknowledgement-note-box">
                <div className="note-label">
                  <span className="note-label-title">Note:</span>
                  <span className="note-label-content">{note}</span>
                </div>
              </div>
            )}
            <div className="popup-action-wrap">
              <div
                className={`popup-action-btn positive-btn ${btnClassName}`}
                onClick={handleAction}
                id={id || ""}
              >
                {actionBtnText}
              </div>
            </div>
          </div>
        </div>
        <div className="confirmation-popup-mask" />
      </div>
    )
  );
};

export { AcknowledgementPopup, acknowledgementPopupState };
export default observer(AcknowledgementPopup);
